// extracted by mini-css-extract-plugin
export default {"wrapper":"ShowSaleContractDetail_wrapper__c86WB","col":"ShowSaleContractDetail_col__MRyKF"};